import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9c610b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-hero mb-5" }
const _hoisted_2 = { class: "profile-hero__avatar" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "profile-hero__avatar-fallback"
}
const _hoisted_5 = { class: "profile-hero__identity" }
const _hoisted_6 = { class: "profile-hero__name" }
const _hoisted_7 = {
  key: 0,
  class: "profile-hero__role mb-1"
}
const _hoisted_8 = { class: "profile-hero__meta mb-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "detail-info-row" }
const _hoisted_11 = { class: "detail-info-pair" }
const _hoisted_12 = { class: "detail-info-pair__label" }
const _hoisted_13 = { class: "detail-info-pair__value" }
const _hoisted_14 = { class: "detail-info-pair" }
const _hoisted_15 = { class: "detail-info-pair__label" }
const _hoisted_16 = { class: "detail-info-pair__value" }
const _hoisted_17 = { class: "detail-info-row" }
const _hoisted_18 = { class: "detail-info-pair" }
const _hoisted_19 = { class: "detail-info-pair__label" }
const _hoisted_20 = { class: "detail-info-pair__value" }
const _hoisted_21 = { class: "detail-info-pair" }
const _hoisted_22 = { class: "detail-info-pair__label" }
const _hoisted_23 = { class: "detail-info-pair__value" }
const _hoisted_24 = { class: "detail-info-row" }
const _hoisted_25 = { class: "detail-info-pair" }
const _hoisted_26 = { class: "detail-info-pair__label" }
const _hoisted_27 = { class: "detail-info-pair__value" }
const _hoisted_28 = { class: "detail-info-pair" }
const _hoisted_29 = { class: "detail-info-pair__label" }
const _hoisted_30 = { class: "detail-info-pair__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoiMatKhauModal = _resolveComponent("DoiMatKhauModal")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DoiMatKhauModal, {
      "is-open": _ctx.isChangePasswordOpen,
      "user-id": _ctx.profile?.id || _ctx.user.id,
      "user-name": _ctx.profile?.ho_va_ten || _ctx.user.fullName,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isChangePasswordOpen = false))
    }, null, 8, ["is-open", "user-id", "user-name"]),
    _createVNode(_component_PageHeaderActions, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageHeaderActionItem, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.push('/quan-ly/tai-khoan/cap-nhat')))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencil }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Chỉnh sửa ")
          ]),
          _: 1
        }),
        _createVNode(_component_PageHeaderActionItem, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isChangePasswordOpen = true))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faKey }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Đổi mật khẩu ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Hồ sơ của tôi")
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.avatarUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.avatarUrl,
                        alt: _ctx.displayName
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_font_awesome_icon, { icon: _ctx.faUser }, null, 8, ["icon"])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.displayName), 1),
                  (_ctx.displayRole)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.displayRole), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.displayPosition) + " ", 1),
                    (_ctx.displayDepartment !== '—')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " · " + _toDisplayString(_ctx.displayDepartment), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tên đăng nhập:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.profile?.ten_dang_nhap || _ctx.user.username || '—'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Số điện thoại:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.profile?.so_dien_thoai || _ctx.user.phone || '—'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Email:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.profile?.email || _ctx.user.email || '—'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Bộ phận:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.displayPart), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Đơn vị:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.displayDepartment), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Chức vụ:")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.displayPosition), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.pageLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}